import { render, staticRenderFns } from "./holidays.vue?vue&type=template&id=aae21280&scoped=true"
import script from "./holidays.vue?vue&type=script&lang=js"
export * from "./holidays.vue?vue&type=script&lang=js"
import style0 from "./holidays.vue?vue&type=style&index=0&id=aae21280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae21280",
  null
  
)

export default component.exports